import axios, { InternalAxiosRequestConfig } from 'axios';
import appSettings from '../appSettings';

const createNewApiClient = (accessToken: string) => {
  const axiosInstance = axios.create({
    baseURL: appSettings.APIM_URL,
    timeout: 15000,
  });

  const configureApiClient = async (config: InternalAxiosRequestConfig) => {
    config.headers['Content-Type'] = 'application/json';
    config.headers['Authorization'] = `Bearer ${accessToken}`;
    return config;
  };

  axiosInstance.interceptors?.request?.use((config) =>
    configureApiClient(config),
  );

  return axiosInstance;
};

export default createNewApiClient;
